import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import 'AppSrc/core/style/components/app-layout/page-content.css';
import 'AppSrc/core/style/components/home-screen/home-screen.css';
import { COORDINATOR } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { FIXED, MOBILE } from 'AppSrc/core/components/forms/value-dependency-constants';
import bannerImage from './home-screen-banner.jpg';
import { CoordinatorWorkQueue } from './coordinator-work-queue';
import { RequestorRecentCrqs } from './requestor-recent-crqs';
import { OutageAlert } from '../outage-banner/outage-alert';



const HomeScreenDisplay = React.memo(({
  isCoordinatorOnANetwork,
  bannerSet,
}) => (
  <React.Fragment>
    { bannerSet ? <OutageAlert /> : '' }
    <div className="page-content-container page-content-container-home">
      <div className="page-content">
        <div
          className="home-screen-banner"
          style={{ backgroundImage: `url(${bannerImage})` }}
        />
        {isCoordinatorOnANetwork ? (
          <CoordinatorWorkQueue />
        ) : (
          <RequestorRecentCrqs />
        )}
      </div>
    </div>
  </React.Fragment>
));

HomeScreenDisplay.propTypes = {
  isCoordinatorOnANetwork: PropTypes.bool,
  bannerSet: PropTypes.bool,
};


/* --- HomeScreen container component --- */

// the parent components can still pass props directly to the presentational component, and mapStateToProps can access them as ownProps
// the presentational component does not know whether its props come from the parent (ownProps) or the container, the difference is only visible in mapStateToProps
const mapStateToProps = (state, ownProps) => {
  const { roles } = state.auth.user;
  let bannerSet = false;
  // console.log('Banner : ', window.location.href.includes('3001'), state.outageBanner.banner);
  if (state.outageBanner.banner) {
    if (window.location.href.includes('.com')) {
      bannerSet = state.outageBanner.banner.outage;
    }
  }
  // const bannerSet = state.outageBanner.banner ? state.outageBanner.banner.outage : false;
  window.sessionStorage.removeItem('getCurrentAdjacentRemedyRef');
  window.sessionStorage.removeItem('statusReason');
  window.sessionStorage.removeItem('relatedCRQId');
  const isCoordinatorOnANetwork = (roles[MOBILE] === COORDINATOR || roles[FIXED] === COORDINATOR);
  return ({
    isCoordinatorOnANetwork,
    bannerSet,
  });
};

const HomeScreen = withRouter(connect(
  mapStateToProps,
)(HomeScreenDisplay));


export {
  HomeScreenDisplay,
  HomeScreen,
};
